import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/backgroundJobs'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout/index'
import Resx from '@/components/Resx'
import { BackgroundJobRow } from './backgroundJobMenuItem'
import LoadingIndicator from '@/components/LoadingIndicator'

class BackgroundJobsWithMore extends React.Component {
  scroll = () => {
    if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 200) {
      this.props.loadBackgroundJobs(this.props.page + 1)
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.allJobs.length !== prevProps.allJobs.length) { this.scroll() }
  }

  componentDidMount () {
    document.addEventListener('scroll', this.scroll)
    if (!this.props.loading) { this.props.loadBackgroundJobs(0) }
  }

  componentWillUnmount () {
    document.removeEventListener('scroll', this.scroll)
  }
  render () {
    const { allJobs, loading } = this.props
    if (loading && !allJobs.length) { return <LoadingIndicator /> }
    return allJobs.map((job) => <BackgroundJobRow key={job.id} {...job} showAllInfo />)
  }
}
class BackgroundJobList extends React.Component {
  render () {
    return (
      <Main className='notifications' path={[{ text: 'Common.BackgroundJobsHistory' }]}>
        <MainTop>
          <MainTopTitle>
            <Resx name='Common.BackgroundJobsHistory' />
          </MainTopTitle>
        </MainTop>
        <MainBody className='background-jobs'>
          <BackgroundJobsWithMore {...this.props} />
        </MainBody>
      </Main>
    )
  }
}

function mapStateToProps (state) {
  return {
    allJobs: state.backgroundJobs.allJobs || [],
    loading: state.backgroundJobs.loading,
    page: state.backgroundJobs.page
  }
}

const mapDispatchToProps = {
  loadBackgroundJobs: actionCreators.loadBackgroundJobs
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundJobList)



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/list.js